import URLParser from '../URLParser'

const pathnameIncludesOne = (...pathParams) => {
  return traffic => {
    const urlObject = new URLParser(traffic.url)
    const pathParts = urlObject.pathname.split('/')
    return pathParams.some(pathParam => pathParts.includes(pathParam))
  }
}

export default pathnameIncludesOne



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/services/trafficAnalyzer/predicates/pathnameIncludesOne.js